import moment from 'moment';

const isValidDate = (dateString) =>
  moment(dateString, 'YYYY-MM-DD', true).isValid();

const hasValue = (value) => Boolean(value?.trim());

export const isValidPeriod = (value) => {
  if (hasValue(value)) {
    const valArr = value.split(',');
    return valArr.length === 2 && valArr.every((v) => isValidDate(v));
  }

  return false;
};

export const isInteger = (value) => {
  if (hasValue(value)) {
    return Number.isInteger(Number(value));
  }

  return false;
};

export const isBoolean = (value) => {
  if (hasValue(value)) {
    return value === 'true' || value === 'false';
  }

  return false;
};
